import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Product {
  productId: string;
  nameLa: string;
  nameEn: string;
  minAge: number;
  maxAge: number;
  productTypeId: number;
  productTypeName: string;
  showInIhub: boolean;
  showInI4u: boolean;
}

export interface Plan {
  planId: string;
  nameLa: string;
  nameEn: string;
  productId: string;
  productNameLa: string;
  productNameEn: string;
  premium?: number;
  premiumTypeId?: number;
  paymentYear?: number;
}

export interface ApplicationStatus {
  id: number;
  statusName: string;
}

export interface Province {
  provCode: string;
  provNameLa: string;
  provNameEn: string;
  country: string;
  agentAgentLivingProvinces: any[];
  agentAgentNativeProvinces: any[];
  agentGuarantees: any[];
  districts: any[];
  hospitals: any[];
  insuredInsuredOfficeProvs: any[];
  insuredInsuredProvs: any[];
  villages: any[];
}

export interface District {
  distCode: string;
  distNameLa: string;
  distNameEn: string;
  provCode: string;
  agentAgentLivingDistricts: any[];
  agentAgentNativeDistricts: any[];
  agentGuarantees: any[];
  insuredInsuredDists: any[];
  insuredInsuredOfficeDists: any[];
  provCodeNavigation: any;
  villages: any[];
}

export interface Village {
  villCode: string;
  villNameLa: string;
  villNameEn: string;
  distId: string;
  provId: string;
  agentAgentLivingVillages: any[];
  agentAgentNativeVillages: any[];
  agentGuarantees: any[];
  dist: any;
  insuredInsuredOfficeVills: any[];
  insuredInsuredVills: any[];
  prov: any;
}

export interface Country {
  countryId: string;
  countryNameLa: string;
  countryNameEn: string;
}

export interface Nationality {
  nationCode: string;
  descLa: string;
  descEn: string;
}

export interface Religion {
  id: number;
  nameLo: string;
  nameEn: string;
}

export interface MaritalStatus {
  maritalStatusId: string;
  maritalStatusNameLa: string;
  maritalStatusNameEn: string;
}

export interface RequireDocument {
  requiredApplicationDocId: string;
  docNameLa: string;
  docNameEn: string;
}

export interface Occupation {
  occuCode: string;
  descLa: string;
  descEn: string;
}

export interface Position {
  positionCode: number;
  descLa: string;
  descEn: string;
}

export interface Relationship {
  relateCode: string;
  descLa: string;
  descEn: string;
}

export interface PremiumType {
  paymentTypeCode: string;
  descLa: string;
  descEn: string;
}

export interface PaymentLocation {
  paymentLocationCode: string;
  descLa: string;
  descEn: string;
}

export interface SalesChannel {
  id: string;
  name: string;
  isDefault: boolean;
}

export interface AttachDocument {
  docId: number;
  refCode: string;
  docType: string;
  docDesc: string;
  docFilePath: string;
  createdAt: string;
  docReferId: string | null;
  updatedAt: string | null;
  docOf: string | null;
  createdBy: number;
}

export interface AttachDocRequest {
  RefCode?: string;
  DocType?: string;
  DocDesc?: string;
  DocReferId?: string;
  DocOf?: string;
  File: File;
}

export interface GenerateApplicationPdfRequest {
  ApplicationId: string;
  AgentSignature: string | null;
  InsuredSignature: string | null;
}

export interface ProductCoverage {
  id: string;
  name: string;
  yearStart: number;
  yearEnd: number;
  coverage: number;
  coverageAmtTypeId: number;
  coverageType: string;
}

export interface BenefitPeople {
  id: string;
  firstNameLo: string;
  lastNameLo: string;
  fullName: string;
  firstNameEn: string;
  lastNameEn: string;
  gender: string;
  genderName: string;
  dob: string;
  age: number;
  relationShipId: string;
  relationshipName: string;
  benefitPercent: number;
  nowProvinceId: string;
  nowDistrictId: string;
  nowVillageId: string;
  nowProvinceName: string;
  nowDistrictName: string;
  nowVillageName: string;
  requireDocumentId: string;
  requireDocumentName: string | null;
  docIssueDt: string | null;
  occupationId: string;
  occupationName?: string;
  requiredDocumentNo: string;
  nowHomeUnit: string;
  phoneNo: string | null;
}

export interface FamilyHealthIssue {
  id: string;
  fullName: string;
  healthIssue: string;
  age: string;
  year: string;
}

export interface HealthCheck {
  Id: number;
  HealthCheckId: number;
  Name: string;
  Type: string;
  SelYn: boolean;
  HealthChkProCode: string;
}

export interface ApplicationDetail {
  applicationNo: string;
  productId: string;
  planId: string;
  productOptionId: string;
  paymentTypeId: string;
  height: string;
  weight: string;
  increaseWeight: string;
  decreaseWeight: string;
  yearsOfSmoking: string;
  smokePerDay: string;
  drugsType: string;
  drugsCapacity: string;
  drugsPerWeek: string;
  yearsOfTakingDrugs: string;
  stopTakingDrugs: string;
  pregnantDesc: string;
  hivDesc: string;
  applicationStatusId: number;
  paymentTermId: number;
  paymentTermCode: string;
  coverageAmt: number;
  premiumAmtPerTime: number;
  premiumAmtPerYear: number;
  totalPremiumAmt: number;
  buyFrom: string;
  familyHealthIssue: boolean;
  weightChange: boolean;
  smoke: boolean;
  alcohol: boolean;
  alcoholDesc: string;
  drug: boolean;
  pregnant: boolean;
  hiv: boolean;
  createdAt: string;
  createdBy: number;
  agentId: number | null;
  insuredCode: string;
  policyNo: string;
  insuredFullName: string;
  planName: string;
  applicationStatusName: string;
  policyStatusName: string;
  agentName: string;
  productName: string;
  initiator: string;
  initiatorPhone: string;
  initiatorRelationship: string;
  initiatorRelationshipName: string;
  initiatorSignatureApp: string;
  chequeNo: string;
  chequeDate: string | null;
  chequeBankName: string;
  paymentLocationId: string;
  disease: boolean;
  diseaseDesc: string;
  weightChangeDesc: string;
  paymentTermName: string;
  paymentTypeName: string;
  paymentLocationName: string;
  reasonRejectFromContractOfficer: string;
  reasonRejectFromMargeting: string | null;
  isCompleteSign: boolean;
  productCoverages: ProductCoverage[];
  benefitPeoples: BenefitPeople[];
  familyHealthIssues: FamilyHealthIssue[];
  healthChecks: HealthCheck[];
  pdfUrl: string | null;
  withdrawBonusYn: string | null;
}

export interface Policy {
  status: string;
  plNo: string;
  appNo: string;
  plTm: string;
  payDay: number;
  efDt: string;
  exDt: string;
  covYy: number;
  payYy: number;
  plSt: string;
  plStId: number;
  buyFrom: string;
  prmPerTm: string;
  notiDesc: string;
  pdfUrl: string | null;
}

export interface ApplicationResponse {
  application: ApplicationDetail;
  policy: Policy;
}

export interface ApplicationCreateRequest {
  insuredAge?: number;
  policyNo: string;
  applicationNo: string;
  initiatorName: string;
  initiatorPhone: string;
  initiatorRelationshipId: string;
  insuredId: string;
  productId: string;
  planId: string;
  coverageAmt: number;
  paymentTermId: number;
  productOptionId: string;
  premiumAmtPerTime: number;
  premiumAmtPerYear: number;
  totalPremiumAmt: number;
  benefitPeoples: BenefitPeople[];
  nowHeight: string;
  nowWeight: string;
  weightChange: boolean;
  weightGain: string;
  weightLose: string;
  cigarette: boolean;
  cigaretteYear: string;
  cigarettePerDay: string;
  alcohol: boolean;
  alcoholDesc: string;
  drug: boolean;
  drugType: string;
  drugQty: string;
  drugPerWeek: string;
  drugDuration: string;
  drugCancel: string;
  pregnant: boolean;
  pregnantDetail: string;
  hiv: boolean;
  hivDetail: string;
  healthIssue: boolean;
  buyFrom: string;
  agentCode: string;
  userId: number;
  paymentTypeId?: string;
  chequeNo?: string;
  chequeDateDay?: string;
  chequeDateMonth?: string;
  chequeDateYear?: string;
  chequeBankName?: string;
  weightChangeDesc?: string;
  paymentLocationId?: string;
  disease: boolean;
  diseaseDesc?: string;
  familyHealthIssues: FamilyHealthIssue[];
  applicationDay?: string;
  applicationMonth?: string;
  applicationYear?: string;
  appDate?: Date;
  withdrawBonusYn?: string;
}

export interface ApplicationUpdateRequest {
  applicationId: string;
  insuredId: string;
  productId: string;
  planId: string;
  coverageAmt: number;
  paymentTermId: number;
  productOptionId: string;
  premiumAmtPerTime: number;
  premiumAmtPerYear: number;
  totalPremiumAmt: number;
  nowHeight: string;
  nowWeight: string;
  weightChange: boolean;
  weightGain: string;
  weightLose: string;
  cigarette: boolean;
  cigaretteYear: string;
  cigarettePerDay: string;
  alcohol: boolean;
  alcoholDesc: string;
  drug: boolean;
  drugType: string;
  drugQty: string;
  drugPerWeek: string;
  drugDuration: string;
  drugCancel: string;
  pregnant: boolean;
  pregnantDetail: string;
  hiv: boolean;
  hivDetail: string;
  healthIssue: boolean;
  buyFrom: string;
  agentCode: string;
  userId: number;
  initiatorName: string;
  initiatorPhone: string;
  initiatorRelationshipId: string;
  paymentTypeId: string;
  chequeNo: string | null;
  chequeDateDay: string | null;
  chequeDateMonth: string | null;
  chequeDateYear: string | null;
  chequeBankName: string | null;
  weightChangeDesc: string;
  paymentLocationId: string;
  disease: boolean;
  diseaseDesc: string;
  familyHealthIssues: FamilyHealthIssue[];
  benefitPeoples: BenefitPeople[];
  deleteBenefitPeopleIdList: string[];
  deletefamilyHealthIssuesIdList: string[];
  withdrawBonusYn?: string;
  applicationDay: string | null;
  applicationMonth: string | null;
  applicationYear: string | null;
  appDate: string | null;
}

export interface UpdateBeneficiariesRequest {
  applicationNo: string;
  benefitPeoples: BenefitPeople[];
  deleteBenefitPeopleIdList: string[];
}

export interface InsuredRequest {
  FirstNameLo: string;
  LastNameLo: string;
  FirstNameEn: string;
  LastNameEn: string;
  Gender: string;
  DobDay: string;
  DobMonth: string;
  DobYear: string;
  NationId: string;
  Religion: string;
  CountryId: string;
  MaritalStatusId: string;
  ImportantDocumentId: string;
  ImportantDocumentExpireDay: string;
  ImportantDocumentExpireMonth: string;
  ImportantDocumentExpireYear: string;
  InseeHubPhone: string;
  NowCountryId: string;
  NowProvinceId: string;
  NowDistrictId: string;
  NowVillageId: string;
  NowPhone: string;
  NowPhoneSos: string;
  NowHomeNo: string;
  NowHomeUnit: string;
  NowEmail: string;
  OfficeCountryId: string;
  OfficeProvinceId: string;
  OfficeDistrictId: string;
  OfficeVillageId: string;
  OfficePhone: string;
  OfficePhoneSos: string;
  OfficeHomeNo: string;
  OfficeHomeUnit: string;
  OfficeEmail: string;
  OccupationId: string;
  PositionId: string;
  JobDescription: string;
  CompanyNewsFeed: boolean;
  ImportantDocumentNo: string;
  ImportantDocumentIssueDay: string;
  ImportantDocumentIssueMonth: string;
  ImportantDocumentIssueYear: string;
  BankName: string;
  BankAccNo: string;
  BankAccName: string;
  StreetNameNow: string;
  StreetNameOffice: string;
  // Reference fields for audit trail
  ApplicationNo?: string;
  PolicyNo?: string;
}

export interface Insured {
  insuredCode: string;
  insuredNameLa: string;
  insuredSurnameLa: string;
  insuredFullNameLa: string;
  insuredFullNameEn: string;
  insuredNameEn: string;
  insuredSurnameEn: string;
  gender: string;
  insuredAge: number;
  insuredDob: string;
  nationCode: string;
  countryOfBirth: string;
  insuredReligion: string;
  maritalStatus: string;
  requiredDocument: string;
  requiredDocumentExpiredDate: string;
  insuredVillId: string;
  insuredHomeRegistNo: string;
  insuredHomeUnitNo: string;
  insuredHomeStreetName: string;
  insuredDistId: string;
  insuredProvId: string;
  insuredCountry: string;
  insuredPhone: string;
  insuredEmergencyCall: string | null;
  insuredEmail: string;
  companyNewsFeed: boolean;
  insuredOfficeVillId: string;
  insuredOfficeHomeRegistNo: string;
  insuredOfficeHomeUnitNo: string;
  insuredOfficeHomeStreetName: string;
  insuredOfficeDistId: string | null;
  insuredOfficeProvId: string;
  officeCountry: string;
  insuredOfficeTel: string | null;
  insuredOfficeEmergencyCall: string | null;
  insuredOccuCode: string;
  insuredJobDesc: string;
  insuredStatusType: number;
  userRegistration: string;
  userId: string | null;
  inseeHubPhone: string | null;
  createdAt: string | null;
  insuredOfficeEmail: string;
  insuredWorkPositionId: string | null;
  requiredDocumentName: string;
  nationName: string;
  maritalStatusName: string;
  villageNameNow: string;
  districtNameNow: string;
  provinceNameNow: string;
  countryName: string;
  villageNameOffice: string;
  districtNameOffice: string | null;
  provinceNameOffice: string;
  insuredStatusTypeName: string;
  occupationName: string;
  positionName: string | null;
  officeCountryName: string;
  requiredDocumentNo: string;
  requiredDocumentIssueDt: string;
  bankName: string;
  bankAccName: string;
  bankAccNo: string;
}

export interface PolicyPayPremiumQuery {
  PolicyNo: string;
}

export interface PolicyPayPremiumResponse {
  policyNo: string;
  applicationNo: string;
  productName: string;
  planName: string;
  customerName: string;
  period: number;
  policyStatusName: string;
  coverageDate: string;
  premium: number;
  insuredCode: string;
  insuredSignature: string | null;
  status: string | null;
  invNo: string | null;
  insuredPhone: string | null;
  paymentHistory?: any[];
}

export interface Bank {
  id: number;
  name: string;
  accountName?: string | null;
  accountNumber?: string | null;
  qrFile: string | null;
  qrFileUrl: string | null;
}

export interface PayPremiumRequest {
  policyNo: string;
  paymentMethod: string;
  chequeNo?: string;
  chequeDate?: string; // DateOnly format: YYYY-MM-DD
  bankId?: number;
  paymentRefFile?: File;
  paymentRefFiles?: File[];
  remark?: string;
  voucherCode?: string;
  voucherId?: number;
  discountAmount?: number;
  finalPremium?: number;
}

export interface PayPremiumSuccessResponse {
  status: '00';
  msg: 'ສຳເລັດ';
}

export interface PayPremiumErrorResponse {
  status: '01';
  msg: string; // Error message in Lao language
}

export interface PayPremiumExceptionResponse {
  message: string; // Error message describing what went wrong
}

export type PayPremiumResponse =
  | PayPremiumSuccessResponse
  | PayPremiumErrorResponse
  | PayPremiumExceptionResponse;

export interface PolicyPayment {
  id: string;
  policyNo: string;
  applicationNo: string;
  period: number;
  paymentRefFile: string | null;
  chequeNo: string | null;
  chequeDate: string | null;
  bankId: number | null;
  createdBy: string;
  createdAt: string;
  paymentType: string;
  amount: number;
  paymentLocationId: string;
  approvedBy: number | null;
  approvedSign: string | null;
  approvedDt: string | null;
  status: string | null; // "00" -> ລໍຖ້າອະນຸມັດ, "01" -> ອະນຸມັດ, "02" -> ຖືກປະຕິເສດ
  payDueDt: string | null;
  yearOfContract: number | null;
  periodOfYear: number | null;
  reasonToCancel: string | null;
  inseeWalletBillNumber: string | null;
  inseeWalletFee: number | null;
  inseePhone: string | null;
  promotionId: string | null;
  discountAmt: number | null;
  premiumAmtBeforeDiscount: number | null;
}

export interface PremiumHistoryParams {
  status?: string;
  policyNo?: string;
  pgNum?: number;
  pgSz?: number;
}

export interface PremiumHistoryResponse {
  count: number;
  dataList: PolicyPayment[];
}

export interface PremiumScheduleQuery {
  pgNum?: number;
  pgSz?: number;
  plNo?: string;
  paymentStatusId?: number;
  startDt?: string; // ISO date string
  endDt?: string; // ISO date string
  selOverAndNotPay?: string;
  appType?: string; // I4U
  agentId?: string; // From token UserCode
}

export interface PremiumScheduleView {
  policyNo: string;
  productId: string;
  planId: string;
  amount: number;
  payDueDt: string;
  periodOfTerm: number;
  paymentStatusId: number; // 0 = unpaid, 1 = paid
  periodOfYear: number;
  paymentStatusName: string;
  insuredCode: string;
  insuredFullNameLa: string;
  gender: string;
  insuredPhone: string;
  inseeHubPhone: string | null;
  agentId: string;
  planNameLa: string;
}

export interface PremiumScheduleResponse {
  status: string;
  count: number;
  pgSz: number;
  pgNum: number;
  dataList: PremiumScheduleView[];
}

export interface PaymentTrackingQuery {
  yearFrom: number;
  yearTo: number;
  policyNo?: string;
  pgIdx?: number;
  pgSz?: number;
}

export interface PaymentTrackingItem {
  policyNo: string;
  insuredFullName: string;
  agentInfo: string;
  productName: string;
  paymentTermName: string;
  effectiveDate: string | null;
  phoneNo: string;
  premiumPerTerm: number;
  totalPaid: number;
  yearMonthStatus: { [year: string]: number[] };
}

export interface PaymentTrackingResponse {
  count: number;
  dataList: PaymentTrackingItem[];
}

export interface PremiumHistoryDetail {
  invNo: string;
  plNo: string;
  apNo: string;
  period: string;
  payRefFile: string | null;
  chNo: string | null;
  chDate: string | null;
  payDt: string;
  amt: string; // Formatted currency string
  planNm: string;
  custNm: string;
  plStatus: string;
  covDt: string;
  bank: string | null;
  bankAccountName?: string | null;
  bankAccountNumber?: string | null;
  payMtLo: string | null;
  payMtTp: string; // TRANSFER, CASH, CHEQUE, IH
  status: string; // PAID, WAITING_APPROVE, etc.
  inseeHubBillNo: string | null;
  inseeHubFee: string | null;
  inseeHubPhone: string | null;
  reason: string | null;
  prodId: string;
  planId: string;
  insuredId: string;
  // Voucher fields
  voucherCode: string | null;
  voucherDiscountAmt: string | null;
  premiumBeforeDiscount: string | null;
  remark: string | null;
}

export interface PremiumHistoryDetailResponse {
  status: string; // "00" = success
  data: PremiumHistoryDetail;
}

export interface AttachDoc {
  docDesc: string;
}

export interface PolicyCoverageDto {
  policyNo: string;
  applicationNo: string;
  insuredCode: string;
  policyCoverageId: number;
  insuredFullName: string;
  productPlan: string;
  bonusType: string;
  coverageAmt: number;
  payDate: string;
  bonusReceivedType: string;
  pcId: number;
  paymentStatus: number;
  productCode: string;
  coverageType: string;
  paymentTerm: string;
  premiumPerYearAmt: number;
  premiumPerTimeAmt: number;
  insuredSignature: string;
}

export interface PolicyPaymentDetailDto {
  policyNo: string;
  applicationNo: string;
  policyCoverageId: number;
  paymentTerm: string;
  actualPay: string;
  extraPaid: string;
  actualPaidTermAfter: string;
  paymentTermAfter: number;
  paymentAmtAfter: number;
  createdBy?: number;
}

export interface PremiumByBonusResponse {
  status: string; // "true" or "false"
  message?: string;
}

export interface PayFromBonusQuery {
  policyNo: string;
  applicationNo: string;
  insuredCode: string;
  policyCoverageId: number;
  paymentTermDecs: string;
  autaulPaymentDesc: string;
  extraPaymentDesc: string;
  autaulPaymentAfterExtra: string;
  statusLa: string;
  statusEn: string;
  rejectReason: string | null;
  pdfUrl: string;
  attachUrl: any[];
  paymentStatusId?: number | null; // optional numeric status id if provided by API
}

export interface PolicyPremiumByBonusPdfResponse {
  pdfPath: string;
  fileName: string;
  message: string;
}

export interface BonusAndCashbackItem {
  policyNo: string;
  productCode: string;
  planId: string;
  peroidYear: number;
  coverageAmt: number;
  coverageType: string;
  payDate: string;
  createdAt: string;
  paymentStatusId: number;
  paymentStatusName: string;
  insuredCode: string;
  insuredFullNameLa: string;
  gender: string;
  insuredPhone: string;
  inseeHubPhone: string;
  agentId: string;
  planNameLa: string;
  bonusType: string;
  notification: string;
}

export interface BonusAndCashbackResponse {
  status: string;
  dataList: BonusAndCashbackItem[];
}

export interface BonusAndCashbackParams {
  policyNo?: string;
  startDate?: string;
  endDate?: string;
  selOverAndNotPay?: string;
  pgNum?: number;
  pgSz?: number;
  agentId: string;
}

export interface CommissionItem {
  agentCode: string;
  agentFullname: string;
  agentMobile: string;
  agentStatusName: string;
  agentTypeName: string;
  ofMonth: string;
  totalPoliciesAmt: string;
  totalCommissionAmt: string;
  paymentStatus: string;
  paymentStatusId: number | null;
  pdfUrl: string;
}

export interface CommissionResponse {
  status: string;
  count: number;
  pgNum: number;
  pgSz: number;
  dataList: CommissionItem[];
}

export interface CommissionParams {
  agentId: string;
  pgNum?: number;
  pgSz?: number;
}

export interface ProductInterested {
  productInterestedId: number;
  cusName: string;
  cusPhone: string;
  productCode: string;
  active: number; // 0 = ຍັງບໍ່ຕິດຕໍ່ (Not contacted), 1 = ຕິດຕໍ່ແລ້ວ (Contacted)
  createDate: string;
  remark: string | null;
  status: string; // "01" = Not contacted, "02" = Sale closed, "03" = Thinking, "04" = Phone off, "05" = Cannot contact
  upBy: number | null;
  upDt: string | null;
  productCodeNavigation: any | null;
}

export interface ProductInterestedParams {
  status?: string;
}

export interface ProvinceNavigation {
  provCode: string;
  provNameLa: string;
  provNameEn: string;
  country: string;
}

export interface Hospital {
  hospitalid: string;
  nameLa: string;
  nameEn: string;
  addressLa: string;
  addressEn: string;
  phone1: string;
  phone2: string;
  fax: string;
  province: string;
  lat: number | null;
  long: number | null;
  country: string;
  phone3: string | null;
  active: boolean;
  provinceNavigation: ProvinceNavigation;
}

export interface HospitalSearchParams {
  hospitalid?: string;
  nameLa?: string;
  nameEn?: string;
  addressLa?: string;
  addressEn?: string;
  phone1?: string;
  phone2?: string;
  fax?: string;
  province?: string;
  lat?: number | null;
  long?: number | null;
}

export interface User {
  userId: number;
  fullname: string;
  userName: string;
  userPassword: string;
  userRoleId: number;
  userStatus: boolean;
  signature: string | null;
  userCode: string;
  hospitalId: string | null;
  hospital: any;
  userRole: any;
}

export interface Agent {
  agentCode: string;
  agentOldCode: string | null;
  agentType: string;
  agentFullname: string;
  agentFirstnameLa: string;
  agentLastnameLa: string;
  agentFirstnameEn: string;
  agentLastnameEn: string;
  agentDob: string;
  agentNativeProvinceId: string;
  agentNativeDistrictId: string;
  agentNativeVillageId: string;
  agentNationCode: string;
  agentOrigin: string;
  agentReligion: string;
  agentLivingProvinceId: string;
  agentLivingDistrictId: string;
  agentLivingVillageId: string;
  agentOccuCode: string;
  agentRole: string;
  agentBelongTo: string;
  agentIdCard: string;
  agentIdCardEntDate: string;
  agentIdCardExpDate: string;
  agentIdCardIssuedAt: string;
  agentHomePhone: string;
  agentMobile: string;
  exInsurance: boolean;
  exInsuranceName: string | null;
  findUs: string;
  findUsOtherChannel: string | null;
  agentProfileImage: string | null;
  suggestionPerson: string;
  agentCreateDate: string;
  licenseNo: string;
  agentStatus: boolean;
  location: string;
  applicationDate: string;
  signature: string | null;
  createdAt: string;
  createdBy: string;
  updatedAt: string | null;
  agentGuaranteeCode: number;
  agentTypeId: number;
  agentGender: string;
  agentSignature: string | null;
  positionCode: string | null;   // AG | LP | UM | SEM (Phase 2 hierarchy)
  parentAgentCode: string | null;
}

export interface UploadAttachmentRequest {
  RefCode: string;
  DocType: string;
  DocDesc: string;
  DocReferId: string;
  DocOf: string;
  File: File;
}

export interface Voucher {
  id: number;
  voucherCode: string;
  voucherType: string; // 'PERCENT' or 'AMOUNT'
  discountValue: number;
  maxDiscount?: number;
  minPurchase?: number;
  startDate: string;
  endDate: string;
  usageLimit: number;
  usedCount: number;
  isActive: boolean;
  description?: string;
  applicableProducts?: string[]; // Product IDs
}

export interface VoucherValidationRequest {
  voucherCode: string;
  policyNo: string;
  premiumAmount: number;
}

export interface VoucherValidationResponse {
  isValid: boolean;
  message: string;
  voucher?: Voucher;
  discountAmount?: number;
  finalAmount?: number;
}

export interface ApplyVoucherRequest {
  voucherCode: string;
  policyNo: string;
  premiumAmount: number;
}

export const EProduct = {
  WHOLE_LIFE: 'WL',
  SAVING: 'SV',
  SHORT: 'ST',
  WHOLE_LIFE_OLD: 'P2301',
  RETIRE: 'RT',
  SAVING_OLD: 'P2302',
} as const;

export const EPaymentTerm = {
  OneMonth: 'MON',
  ThreeMonth: '3MO',
  SixMonth: '6MO',
  Year: 'YEL',
} as const;

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAllProduct(): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.apiUrl}/product`);
  }

  getAllPlanByProductId(productId: string): Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.apiUrl}/product/${productId}/plans`);
  }

  getAllProductOptionByPlanId(planId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/Product/plan/${planId}/options`);
  }

  getAllProductCoverageByPlanId(planId: string): Observable<ProductCoverage[]> {
    return this.http.get<ProductCoverage[]>(`${this.apiUrl}/Product/plan/${planId}/coverages`);
  }

  getAllPaymentTermByProductId(productId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/product/${productId}/payment-terms`);
  }

  getPremiumByPaymentTerm(planId: string, paymentTerm: string): Observable<any> {
    const params = new HttpParams().set('planId', planId).set('paymentTerm', paymentTerm);
    return this.http.get<any>(`${this.apiUrl}/Common/premium-by-payment-term`, { params });
  }

  getAllApplicationStatus(): Observable<ApplicationStatus[]> {
    return this.http.get<ApplicationStatus[]>(`${this.apiUrl}/common/application-status`);
  }

  getApplicationById(id: string): Observable<ApplicationResponse> {
    return this.http.get<ApplicationResponse>(`${this.apiUrl}/application/${id}`);
  }

  getPayPremium(policyNo: string): Observable<PolicyPayPremiumResponse> {
    const params = new HttpParams().set('plNo', policyNo);
    return this.http.get<PolicyPayPremiumResponse>(`${this.apiUrl}/premium/policy-for-pay`, {
      params,
    });
  }

  getAllBanks(): Observable<Bank[]> {
    return this.http.get<Bank[]>(`${this.apiUrl}/common/banks`);
  }

  payPremium(paymentData: PayPremiumRequest): Observable<PayPremiumResponse> {
    const formData = new FormData();
    formData.append('policyNo', paymentData.policyNo);
    formData.append('paymentMethod', paymentData.paymentMethod);

    if (paymentData.chequeNo) {
      formData.append('chequeNo', paymentData.chequeNo);
    }
    if (paymentData.chequeDate) {
      formData.append('chequeDate', paymentData.chequeDate);
    }
    if (paymentData.bankId !== undefined && paymentData.bankId !== null) {
      formData.append('bankId', paymentData.bankId.toString());
    }

    // Support multiple files
    if (paymentData.paymentRefFiles && paymentData.paymentRefFiles.length > 0) {
      paymentData.paymentRefFiles.forEach((file, index) => {
        formData.append('paymentRefFiles', file);
      });
    } else if (paymentData.paymentRefFile) {
      // Backward compatibility
      formData.append('paymentRefFile', paymentData.paymentRefFile);
    }

    // Add remark if provided
    if (paymentData.remark) {
      formData.append('remark', paymentData.remark);
    }

    // Add voucher data if provided
    if (paymentData.voucherCode) {
      formData.append('voucherCode', paymentData.voucherCode);
    }
    if (paymentData.voucherId !== undefined && paymentData.voucherId !== null) {
      formData.append('voucherId', paymentData.voucherId.toString());
    }
    if (paymentData.discountAmount !== undefined && paymentData.discountAmount !== null) {
      formData.append('discountAmount', paymentData.discountAmount.toString());
    }
    if (paymentData.finalPremium !== undefined && paymentData.finalPremium !== null) {
      formData.append('finalPremium', paymentData.finalPremium.toString());
    }

    return this.http.post<PayPremiumResponse>(`${this.apiUrl}/premium/pay`, formData);
  }

  getPremiumHistory(params?: PremiumHistoryParams): Observable<PremiumHistoryResponse> {
    let httpParams = new HttpParams();

    if (params?.status) {
      httpParams = httpParams.set('status', params.status);
    }
    if (params?.policyNo) {
      httpParams = httpParams.set('policyNo', params.policyNo);
    }
    if (params?.pgNum !== undefined) {
      httpParams = httpParams.set('pgNum', params.pgNum.toString());
    }
    if (params?.pgSz !== undefined) {
      httpParams = httpParams.set('pgSz', params.pgSz.toString());
    }

    return this.http.get<PremiumHistoryResponse>(`${this.apiUrl}/premium/history`, {
      params: httpParams,
    });
  }

  getPremiumSchedule(params?: PremiumScheduleQuery): Observable<PremiumScheduleResponse> {
    let httpParams = new HttpParams();

    // Always include required params
    if (params?.pgNum !== undefined && params?.pgNum !== null) {
      httpParams = httpParams.set('pgNum', params.pgNum.toString());
    }
    if (params?.pgSz !== undefined && params?.pgSz !== null) {
      httpParams = httpParams.set('pgSz', params.pgSz.toString());
    }

    // Required params for I4U
    if (params?.appType) {
      httpParams = httpParams.set('appType', params.appType);
    }
    if (params?.agentId) {
      httpParams = httpParams.set('agentId', params.agentId);
    }

    // Optional filter params - only add if they have values
    if (params?.plNo) {
      httpParams = httpParams.set('plNo', params.plNo);
    }
    if (
      params?.paymentStatusId !== undefined &&
      params?.paymentStatusId !== null &&
      params?.paymentStatusId !== -1
    ) {
      httpParams = httpParams.set('paymentStatusId', params.paymentStatusId.toString());
    }
    if (params?.startDt) {
      httpParams = httpParams.set('startDt', params.startDt);
    }
    if (params?.endDt) {
      httpParams = httpParams.set('endDt', params.endDt);
    }
    if (params?.selOverAndNotPay) {
      httpParams = httpParams.set('selOverAndNotPay', params.selOverAndNotPay);
    }

    return this.http.get<PremiumScheduleResponse>(`${this.apiUrl}/premium/schedule`, {
      params: httpParams,
    });
  }

  getPaymentTracking(params: PaymentTrackingQuery): Observable<PaymentTrackingResponse> {
    let httpParams = new HttpParams()
      .set('yearFrom', params.yearFrom.toString())
      .set('yearTo', params.yearTo.toString());

    if (params.policyNo) {
      httpParams = httpParams.set('policyNo', params.policyNo);
    }
    if (params.pgIdx !== undefined) {
      httpParams = httpParams.set('pgIdx', params.pgIdx.toString());
    }
    if (params.pgSz !== undefined) {
      httpParams = httpParams.set('pgSz', params.pgSz.toString());
    }

    return this.http.get<PaymentTrackingResponse>(`${this.apiUrl}/premium/tracking`, {
      params: httpParams,
    });
  }

  getPremiumHistoryDetail(invNo: string): Observable<PremiumHistoryDetailResponse> {
    return this.http.get<PremiumHistoryDetailResponse>(`${this.apiUrl}/premium/history/${invNo}`);
  }

  getAttachDocuments(invNo: string): Observable<AttachDocument[]> {
    return this.http.get<AttachDocument[]>(`${this.apiUrl}/attachdoc/${invNo}`);
  }

  getPolicyBonus(policyNo: string): Observable<PolicyCoverageDto> {
    return this.http.get<PolicyCoverageDto>(`${this.apiUrl}/premium/policy-bonus/${policyNo}`);
  }

  payPremiumByBonus(paymentDetail: PolicyPaymentDetailDto): Observable<PremiumByBonusResponse> {
    return this.http.post<PremiumByBonusResponse>(
      `${this.apiUrl}/premium/premium-by-bonus`,
      paymentDetail
    );
  }

  getPayFromBonusList(): Observable<PayFromBonusQuery[]> {
    return this.http.get<PayFromBonusQuery[]>(`${this.apiUrl}/premium/payfrombonus`);
  }

  getPolicyPremiumByBonusPdf(pid: string): Observable<PolicyPremiumByBonusPdfResponse> {
    const params = new HttpParams().set('format', 'pdf');
    return this.http.get<PolicyPremiumByBonusPdfResponse>(
      `${this.apiUrl}/premium/premium-by-bonus/${pid}`,
      { params }
    );
  }

  getBonusAndCashback(queryParams: BonusAndCashbackParams): Observable<BonusAndCashbackResponse> {
    let params = new HttpParams().set('agentId', queryParams.agentId);

    if (queryParams.policyNo) {
      params = params.set('policyNo', queryParams.policyNo);
    }
    if (queryParams.startDate) {
      params = params.set('startDate', queryParams.startDate);
    }
    if (queryParams.endDate) {
      params = params.set('endDate', queryParams.endDate);
    }
    if (queryParams.selOverAndNotPay !== undefined) {
      params = params.set('selOverAndNotPay', String(queryParams.selOverAndNotPay));
    }
    if (queryParams.pgNum !== undefined) {
      params = params.set('pgNum', String(queryParams.pgNum));
    }
    if (queryParams.pgSz !== undefined) {
      params = params.set('pgSz', String(queryParams.pgSz));
    }

    return this.http.get<BonusAndCashbackResponse>(`${this.apiUrl}/bonusandcashback`, { params });
  }

  getCommission(queryParams: CommissionParams): Observable<CommissionResponse> {
    let params = new HttpParams().set('agentId', queryParams.agentId);

    if (queryParams.pgNum !== undefined) {
      params = params.set('pgNum', String(queryParams.pgNum));
    }
    if (queryParams.pgSz !== undefined) {
      params = params.set('pgSz', String(queryParams.pgSz));
    }

    return this.http.get<CommissionResponse>(`${this.apiUrl}/commission`, { params });
  }

  getProductInterested(queryParams?: ProductInterestedParams): Observable<ProductInterested[]> {
    let params = new HttpParams();

    if (queryParams?.status) {
      params = params.set('status', queryParams.status);
    }

    return this.http.get<ProductInterested[]>(`${this.apiUrl}/product/interested`, { params });
  }

  updateProductInterested(id: number, params: { statusId: string }): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/product/interested/${id}`, params);
  }

  getProductInterestedNewCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.apiUrl}/product/interested/count/new`);
  }

  getHospitalsList(searchParams: HospitalSearchParams): Observable<Hospital[]> {
    return this.http.post<Hospital[]>(`${this.apiUrl}/hospital/list`, searchParams);
  }

  getHospitalById(code: string): Observable<Hospital> {
    return this.http.get<Hospital>(`${this.apiUrl}/hospital/${code}`);
  }

  getInsuredById(id: string): Observable<Insured> {
    return this.http.get<Insured>(`${this.apiUrl}/insured/${id}`);
  }

  createNewInsured(insuredData: InsuredRequest): Observable<Insured> {
    return this.http.post<any>(`${this.apiUrl}/insured`, insuredData);
  }

  updateInsured(id: string, insuredData: InsuredRequest, changeReason: string): Observable<Insured> {
    const params = new HttpParams().set('changeReason', changeReason);
    return this.http.put<any>(`${this.apiUrl}/insured/${id}`, insuredData, { params });
  }

  saveApplication(
    applicationData: ApplicationCreateRequest
  ): Observable<{ applicationId: string; message: string }> {
    return this.http.post<{ applicationId: string; message: string }>(
      `${this.apiUrl}/application`,
      applicationData
    );
  }

  updateApplication(
    id: string,
    applicationData: ApplicationUpdateRequest,
    changeReason: string
  ): Observable<ApplicationResponse> {
    const params = new HttpParams().set('changeReason', changeReason);
    return this.http.put<ApplicationResponse>(`${this.apiUrl}/application`, applicationData, { params });
  }

  updateBeneficiaries(request: UpdateBeneficiariesRequest, changeReason: string): Observable<{ Message: string }> {
    const params = new HttpParams().set('changeReason', changeReason);
    return this.http.put<{ Message: string }>(`${this.apiUrl}/application/beneficiaries`, request, { params });
  }

  submitApplicationToReview(applicationId: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.apiUrl}/application/${applicationId}/submit-to-review`,
      {}
    );
  }

  getAllProvince(): Observable<Province[]> {
    return this.http.get<Province[]>(`${this.apiUrl}/common/provinces`);
  }

  getAllDistrict(provinceCode: string): Observable<District[]> {
    const params = new HttpParams().set('provinceCode', provinceCode);
    return this.http.get<District[]>(`${this.apiUrl}/common/districts`, { params });
  }

  getAllVillage(districtCode: string): Observable<Village[]> {
    const params = new HttpParams().set('districtCode', districtCode);
    return this.http.get<Village[]>(`${this.apiUrl}/common/villages`, { params });
  }

  getAllCountry(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.apiUrl}/common/countries`);
  }

  getAllNationality(): Observable<Nationality[]> {
    return this.http.get<Nationality[]>(`${this.apiUrl}/common/nationality`);
  }

  getAllReligion(): Observable<Religion[]> {
    return this.http.get<Religion[]>(`${this.apiUrl}/common/religion`);
  }

  getAllMaritalStatus(): Observable<MaritalStatus[]> {
    return this.http.get<MaritalStatus[]>(`${this.apiUrl}/common/marital-status`);
  }

  getAllRequireDocument(): Observable<RequireDocument[]> {
    return this.http.get<RequireDocument[]>(`${this.apiUrl}/common/require-document`);
  }

  getAllOccupation(): Observable<Occupation[]> {
    return this.http.get<Occupation[]>(`${this.apiUrl}/common/occupation`);
  }

  getAllPosition(): Observable<Position[]> {
    return this.http.get<Position[]>(`${this.apiUrl}/common/position`);
  }

  getAllRelationship(): Observable<Relationship[]> {
    return this.http.get<Relationship[]>(`${this.apiUrl}/common/relationship`);
  }

  getAllPremiumType(): Observable<PremiumType[]> {
    return this.http.get<PremiumType[]>(`${this.apiUrl}/common/payment-type`);
  }

  getAllPaymentLocation(): Observable<PaymentLocation[]> {
    return this.http.get<PaymentLocation[]>(`${this.apiUrl}/common/payment-location`);
  }

  getAllSalesChannels(): Observable<SalesChannel[]> {
    return this.http.get<SalesChannel[]>(`${this.apiUrl}/common/sales-channels`);
  }

  getAllAttachDocByAppId(appId: string): Observable<AttachDocument[]> {
    return this.http.get<AttachDocument[]>(`${this.apiUrl}/attachdoc/${appId}`);
  }

  addAttachDoc(attachDocData: AttachDocRequest): Observable<AttachDocument> {
    const formData = new FormData();

    if (attachDocData.RefCode) {
      formData.append('RefCode', attachDocData.RefCode);
    }
    if (attachDocData.DocType) {
      formData.append('DocType', attachDocData.DocType);
    }
    if (attachDocData.DocDesc) {
      formData.append('DocDesc', attachDocData.DocDesc);
    }
    if (attachDocData.DocReferId) {
      formData.append('DocReferId', attachDocData.DocReferId);
    }
    if (attachDocData.DocOf) {
      formData.append('DocOf', attachDocData.DocOf);
    }
    formData.append('File', attachDocData.File);

    return this.http.post<AttachDocument>(`${this.apiUrl}/AttachDoc`, formData);
  }

  /** Same upload as addAttachDoc but emits HttpEvents so callers can render upload progress */
  addAttachDocWithProgress(attachDocData: AttachDocRequest): Observable<HttpEvent<AttachDocument>> {
    const formData = new FormData();

    if (attachDocData.RefCode) {
      formData.append('RefCode', attachDocData.RefCode);
    }
    if (attachDocData.DocType) {
      formData.append('DocType', attachDocData.DocType);
    }
    if (attachDocData.DocDesc) {
      formData.append('DocDesc', attachDocData.DocDesc);
    }
    if (attachDocData.DocReferId) {
      formData.append('DocReferId', attachDocData.DocReferId);
    }
    if (attachDocData.DocOf) {
      formData.append('DocOf', attachDocData.DocOf);
    }
    formData.append('File', attachDocData.File);

    return this.http.post<AttachDocument>(`${this.apiUrl}/AttachDoc`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  deleteAttachDoc(applicationId: string, attachId: string, changeReason?: string): Observable<any> {
    if (changeReason) {
      const params = new HttpParams().set('changeReason', changeReason);
      return this.http.delete(`${this.apiUrl}/AttachDoc/${applicationId}/attachment/${attachId}`, { params });
    }
    return this.http.delete(`${this.apiUrl}/AttachDoc/${applicationId}/attachment/${attachId}`);
  }

  generateApplicationPdf(pdfData: GenerateApplicationPdfRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/Application/generate-pdf`, pdfData);
  }

  updateUserSignature(userId: number, signature: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/common/user-signature`, { userId, signature });
  }

  getUserSignature(userId: string | number): Observable<{ signature: string | null }> {
    return this.http.get<{ signature: string | null }>(
      `${this.apiUrl}/common/user-signature/${userId}`
    );
  }

  searchInsuredByFullName(name?: string, phone?: string): Observable<Insured[]> {
    let params = new HttpParams();
    if (name) {
      params = params.set('name', name);
    }
    if (phone) {
      params = params.set('phone', phone);
    }
    return this.http.get<Insured[]>(`${this.apiUrl}/insured`, { params });
  }

  formatDate(date: Date | string, format: string = 'dd/MM/yyyy'): string | null {
    const d = new Date(date);
    if (format === 'dd/MM/yyyy') {
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return d.toLocaleDateString();
  }

  buildHttpParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        httpParams = httpParams.set(key, params[key].toString());
      }
    });
    return httpParams;
  }

  handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    throw error;
  }

  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }

  debounce(func: Function, wait: number): Function {
    let timeout: any;
    return function executedFunction(...args: any[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  formatCurrency(amount: number, currency: string = 'LAK'): string {
    return new Intl.NumberFormat('lo-LA', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }

  formatNumber(num: number): string {
    return new Intl.NumberFormat('lo-LA').format(num);
  }

  downloadFile(data: Blob, filename: string): void {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  base64ToBlob(base64: string, contentType: string = ''): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  getRandomId(): string {
    return (
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    );
  }

  sortArray<T>(array: T[], key: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
    return array.sort((a, b) => {
      if (a[key] < b[key]) {
        return order === 'asc' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  groupBy<T>(array: T[], key: keyof T): { [key: string]: T[] } {
    return array.reduce((result, currentValue) => {
      const groupKey = String(currentValue[key]);
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(currentValue);
      return result;
    }, {} as { [key: string]: T[] });
  }

  // Get User by ID
  getUserById(userId: number): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/common/user/${userId}`);
  }

  // Get Agent by Code
  getAgentByCode(agentCode: string): Observable<Agent> {
    return this.http.get<Agent>(`${this.apiUrl}/common/agent/${agentCode}`);
  }

  // Get Attachments by RefCode
  getAttachmentsByRefCode(refCode: string): Observable<AttachDocument[]> {
    return this.http.get<AttachDocument[]>(`${this.apiUrl}/attachdoc/${refCode}`);
  }

  // Upload Attachment to S3
  uploadAttachment(
    formData: FormData
  ): Observable<{ status: string; msg: string; data: AttachDocument }> {
    return this.http.post<{ status: string; msg: string; data: AttachDocument }>(
      `${this.apiUrl}/attachdoc`,
      formData
    );
  }

  // Delete Attachment
  deleteAttachment(docId: number): Observable<{ status: string; msg: string }> {
    return this.http.delete<{ status: string; msg: string }>(`${this.apiUrl}/attachdoc/${docId}`);
  }

  // Upload agent profile photo — syncs to agent.agent_profile_image (S3 PublicRead, no expiry)
  uploadAgentProfileImage(file: File): Observable<{ status: string; imageUrl: string; key: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ status: string; imageUrl: string; key: string }>(
      `${this.apiUrl}/attachdoc/profile-image`,
      formData
    );
  }

  // Build public CDN URL from agent.agentProfileImage key
  getAgentProfileImageUrl(key: string): string {
    return `https://sgp1.digitaloceanspaces.com/inseecdn/insurance/${key}`;
  }

  localStorage = {
    set: (key: string, value: any): void => {
      localStorage.setItem(key, JSON.stringify(value));
    },
    get: (key: string): any => {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    },
    remove: (key: string): void => {
      localStorage.removeItem(key);
    },
    clear: (): void => {
      localStorage.clear();
    },
  };

  sessionStorage = {
    set: (key: string, value: any): void => {
      sessionStorage.setItem(key, JSON.stringify(value));
    },
    get: (key: string): any => {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    },
    remove: (key: string): void => {
      sessionStorage.removeItem(key);
    },
    clear: (): void => {
      sessionStorage.clear();
    },
  };

  // Voucher APIs
  validateVoucher(request: VoucherValidationRequest): Observable<VoucherValidationResponse> {
    return this.http.post<VoucherValidationResponse>(
      `${this.apiUrl}/premium/voucher/validate`,
      request
    );
  }

  applyVoucher(request: ApplyVoucherRequest): Observable<{ status: string; message: string }> {
    return this.http.post<{ status: string; message: string }>(
      `${this.apiUrl}/premium/voucher/apply`,
      request
    );
  }

  getAllActiveVouchers(): Observable<Voucher[]> {
    return this.http.get<Voucher[]>(`${this.apiUrl}/premium/voucher/active`);
  }

  // Search Beneficiaries
  searchBeneficiaries(params: {
    firstName?: string;
    lastName?: string;
    phoneNo?: string;
  }): Observable<BenefitPeople[]> {
    let httpParams = new HttpParams();

    if (params.firstName) {
      httpParams = httpParams.set('firstName', params.firstName);
    }
    if (params.lastName) {
      httpParams = httpParams.set('lastName', params.lastName);
    }
    if (params.phoneNo) {
      httpParams = httpParams.set('phoneNo', params.phoneNo);
    }

    return this.http.get<BenefitPeople[]>(`${this.apiUrl}/application/beneficiaries/search`, {
      params: httpParams,
    });
  }
}
